import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@cred/react-text'
import { SubmitButton as Button } from '@cred/react-button'
import './styles.scss'

const MortgagesSubmitButton = ({ loading, disabled, hasIcon, error, children, ...props }) => {
  const { formData } = props,
    errors = formData && (formData.syncErrors || formData.asyncErrors),
    _disabled = disabled
      || !!(errors && Object.keys(errors).length)
      || loading
      || !!(formData && formData.asyncValidating)

  return (
    <>
      <Button {...props} disabled={_disabled}>
        {children}{' '}
        {loading ? (
          <i styleName="loading" className="cred-icon icon-cached" />
        ) : (
          hasIcon && <i className="cred-icon icon-chevron-right" />
        )}
      </Button>
      <Text type="caption" styleName="error-message" className="mt-8">
        {error}
      </Text>
    </>
  )
}

MortgagesSubmitButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]).isRequired,
  formData: PropTypes.shape({
    asyncErrors: PropTypes.object,
    syncErrors: PropTypes.object,
    asyncValidating: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasIcon: PropTypes.bool,
}

MortgagesSubmitButton.defaultProps = {
  formData: null,
  loading: false,
  disabled: false,
  hasIcon: true,
  error: '',
}

export { MortgagesSubmitButton }
export default MortgagesSubmitButton
